export default class CMPError extends Error {
}
